<template>
  <DropdownMenu>
    <!-- Optional: Custom trigger icon -->
    <template #trigger>
      <font-awesome-icon :icon="['fas','ellipsis']"/>
    </template>

    <!-- Menu items -->
    <div v-for="(item, index) in menuItems" :key="item.label + index">
      <DropdownMenuItem @click="handleItemClick(item)">
        {{ item.label }}
      </DropdownMenuItem>
    </div>
  </DropdownMenu>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DropdownMenu from '@/components/widgetcomponents/ui/DropdownMenu.vue';
import DropdownMenuItem from '@/components/widgetcomponents/ui/DropdownMenuItem.vue';

export default {
  components: {
    FontAwesomeIcon,
    DropdownMenu,
    DropdownMenuItem,
  },
  data() {
    return {
      menuItems: this.params.menuItems,
    };
  },
  methods: {
    handleItemClick(item) {
      item.action && item.action(this.params);
    }
  }
};
</script>
